import React, { useState } from 'react';
import {Navigate, useNavigate} from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import "./Login.css";
import paperplane from '../../img/paperplane.png';
import {useTranslation} from "react-i18next";

export const Login = () => {
    const [mode, setMode] = useState('login'); // 'login' или 'register'
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [formLoading, setFormLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { t } = useTranslation();


    const { login, register, loading, accessToken } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormLoading(true);
        setError(null);
        if (username.trim() === '' || password.length < 4) {
            setError(t('login.invalidLoginError'));
            setFormLoading(false);
            return;
        }

        const result = mode === 'login'
            ? await login(username, password)
            : await register(username, password);

        setFormLoading(false);

        if (result.accessToken) {
            navigate('/portal');
        } else {
            setError(result.error || t('login.simpleError'));
        }
    };
    if (accessToken) return <Navigate to="/portal" replace />;
    return (
        <div className="loginPage">
            <div className="loginPageContainer">
                <div className="loginPic">
                    {/*<div className="loginInner" />*/}
                    <img alt='smsretail' className="image" src={paperplane} />
                    {/*<div className="authrow">*/}
                        {/*<div className="authLogoFull">*/}
                        {/*    <div className="authLogo">smsretail</div>*/}
                        {/*</div>*/}
                    {/*</div>*/}
                </div>


                <div className="login-details">
                    <div className="login-header">{mode === 'login' ? t('login.signInHeader') : t('login.registrationHeader')}</div>
                    <div className="loginFrame">
                        <input
                            type="text"
                            placeholder={t('login.usernamePlaceholder')}
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="loginInput"
                            disabled={formLoading }
                        />
                        <input
                            type="password"
                            placeholder={t('login.passwordPlaceholder')}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="loginInput"
                            disabled={formLoading }
                        />
                    </div>
                    {error && <div className="loginError" style={{ color: '#268DFF' }}>{error}</div>}
                    <div className="loginFrame2">
                        <button onClick={handleSubmit} className="button" disabled={formLoading}>
                            <div className="text-wrapper">{formLoading  ? 'Загрузка...' : mode === 'login' ? t('login.signInButton') : t('login.registrationButton')}</div>
                        </button>
                        <button
                            onClick={() => {
                                setMode((prevMode) => (prevMode === 'login' ? 'register' : 'login'));
                                setError(null);
                            }}
                            className="button-2"
                            disabled={formLoading}
                        >
                            <div className="buttonMode">
                                {mode === 'login' ? t('login.registrationButton') : t('login.signInButton')}
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
